/**
 * Tiny external store that lets the Extract/Review actions re-fetch their
 * pending count after the user changes it — running an extraction or submitting
 * a review. The action-state hook subscribes; the surfaces `bump()` on success.
 * (No react-query in this app, so this stands in for query invalidation.)
 */
let version = 0;
const listeners = new Set<() => void>();

/** Signal that this app's findings changed; wakes every subscribed action. */
export function bumpFindings(): void {
  version += 1;
  for (const listener of listeners) listener();
}

export function subscribeFindings(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getFindingsVersion(): number {
  return version;
}
